import { MembershipTier, membershipTierToDeviceDisplayName } from '@/lib/constants/maverick';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useTranslation } from '@whoop/i18n/lang/client';
import { useMemo, useState } from 'react';
import { Button, Loading, UnstyledButton } from 'ui';
import { CaretUp } from 'ui/icons/icons/Navigation/CaretUp';
import { useShallow } from 'zustand/react/shallow';
interface StickyCtaProps {
  softSelectedTier: MembershipTier;
  onChangeClick: () => void;
  onContinueClick: () => void;
  usersCurrentTier?: MembershipTier;
}
export default function StickyCta({
  softSelectedTier,
  onChangeClick,
  onContinueClick,
  usersCurrentTier
}: StickyCtaProps) {
  const {
    t
  } = useTranslation('membershipTiers');
  const [isLoading, setIsLoading] = useState(false);
  const {
    isRafGiftFlow
  } = useSiteStore(useShallow(state => ({
    isRafGiftFlow: state.isRafGiftFlow
  })));
  const handleClick = async () => {
    setIsLoading(true);
    await onContinueClick();
  };
  let ctaText = useMemo(() => {
    if (usersCurrentTier === softSelectedTier) {
      return t('upgradeToDevice', {
        device: membershipTierToDeviceDisplayName[softSelectedTier]
      });
    } else if (usersCurrentTier) {
      return t('upgradeToTierDevice', {
        device: membershipTierToDeviceDisplayName[softSelectedTier],
        tier: softSelectedTier
      });
    } else if (isRafGiftFlow) {
      return t('giftTier', {
        tier: softSelectedTier
      });
    } else {
      return t('startWithTier', {
        tier: softSelectedTier
      });
    }
  }, [usersCurrentTier, softSelectedTier, isRafGiftFlow]);
  return <div className='border-gray-a10 shadow-top z-drawer desktop:px-24 sticky bottom-0 left-0 right-0 flex items-center justify-between border-t bg-white px-4 py-4 sm:justify-end' data-sentry-component="StickyCta" data-sentry-source-file="StickyCta.tsx">
      <UnstyledButton className='z-drawer flex min-w-fit flex-grow select-none items-center py-4 pl-2 pr-4 sm:max-w-fit' onClick={onChangeClick} data-sentry-element="UnstyledButton" data-sentry-source-file="StickyCta.tsx">
        <p className='decoration-gray-30 pr-2 text-xs font-bold uppercase tracking-wide underline underline-offset-2'>
          {t('change')}
        </p>
        <CaretUp height={12} width={12} fill='black' strokeWidth={4} data-sentry-element="CaretUp" data-sentry-source-file="StickyCta.tsx" />
      </UnstyledButton>
      <Button variant='secondary' onClick={handleClick} size='medium' disabled={isLoading} className='text-xs font-bold uppercase sm:max-w-60' data-testid='sticky-cta-button' data-sentry-element="Button" data-sentry-source-file="StickyCta.tsx">
        {ctaText}
        {isLoading ? <Loading size='small' /> : null}
      </Button>
    </div>;
}